import {
  ConsentDocument,
  ConsentDocumentActiveStage,
  ConsentDocumentStatus,
  ConsentSignerRole,
  ConsentSignatoryState,
} from "@source/api/models/consentModels";

export const filterAwaitingSignDocuments = (
  documents: ConsentDocument[],
  search: string,
  dateRange: [Date, Date] | [Date] | null,
) => {
  const normalizedSearch = search.trim().toLocaleLowerCase();
  const start = dateRange?.[0] ? new Date(dateRange[0].getFullYear(), dateRange[0].getMonth(), dateRange[0].getDate()).getTime() : undefined;
  const endDate = dateRange?.[1] || dateRange?.[0];
  const end = endDate ? new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999).getTime() : undefined;

  return documents.filter((document) => {
    const searchable = [
      document.title,
      document.resident?.firstName,
      document.resident?.lastName,
      document.categorySnapshot?.name,
      document.nursingHome?.name,
    ].filter(Boolean).join(" ").toLocaleLowerCase();
    const sentAt = document.sentAt ? new Date(document.sentAt).getTime() : NaN;
    return (!normalizedSearch || searchable.includes(normalizedSearch))
      && (start === undefined || (!Number.isNaN(sentAt) && sentAt >= start))
      && (end === undefined || (!Number.isNaN(sentAt) && sentAt <= end));
  });
};

export const canCurrentEmployeeSign = (document: ConsentDocument, employeeId: string) => {
  if (
    !employeeId
    || document.status !== ConsentDocumentStatus.AWAITING_SIGNATURES
    || !Array.isArray(document.activeStages)
    || !document.activeStages.includes(ConsentDocumentActiveStage.AWAITING_EMPLOYEE_SIGNATURES)
  ) return false;

  if (document.signatories !== undefined) {
    return document.signatories.some((signatory) =>
      signatory.id === employeeId
      && signatory.role === ConsentSignerRole.EMPLOYEE
      && signatory.state === ConsentSignatoryState.ACTIVE
      && !signatory.signed,
    );
  }

  const isRequiredEmployee = document.requiredEmployeeSigners?.some((employee) => employee._id === employeeId);
  const hasSigned = document.signatures?.some((signature) => signature.signerId === employeeId);
  return Boolean(isRequiredEmployee && !hasSigned);
};

export const getEmployeeSignSuccessTitle = (status: ConsentDocumentStatus) =>
  status === ConsentDocumentStatus.COMPLETED
    ? "Document completed"
    : "You signed · Waiting for other required signers";
